import * as React from "react";
import "./profileTop.css";
import "../../style/App.css";
import moment from "moment";
import stars from "../../icons/three_stars.png";
import translate from "../../translations/i18n";

export interface Props {
  username: string;
  stars_total: number;
  start_date: number;
}

class UserInfo extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className="USERNAME">{this.props.username}</div>
      </div>
    );
  }
}

export default UserInfo;



// WEBPACK FOOTER //
// ./src/components/profileTop/userInfo.tsx